import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ArrowDown from 'dibs-vg/dist/react/arrow-down';

import style from './ReadMoreButton.scss';

export function ReadMoreButton(props) {
    const { isExpanded, className, onClick, readLessMessage, readMoreMessage } = props;
    const arrowClassName = classnames(style.arrow, {
        [style.expanded]: isExpanded,
    });

    return (
        <div
            className={classnames(style.button, className)}
            onClick={onClick}
            dataTn={`${isExpanded ? 'read-less' : 'read-more'}`}
        >
            {isExpanded ? readLessMessage : readMoreMessage}
            <ArrowDown className={arrowClassName} />
        </div>
    );
}

ReadMoreButton.propTypes = {
    isExpanded: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    readMoreMessage: PropTypes.node.isRequired,
    readLessMessage: PropTypes.node.isRequired,
};
